import { getMobilePlatform } from '@/utils/mobilePlatform'

const isChromiumBrowser = (): boolean => {
    const userAgent = navigator.userAgent.toLowerCase()
    // Chromium-based browsers (Chrome, Edge, Brave, Opera, Vivaldi, Arc, etc.) all
    // include "chrome" in their UA and can install Chrome Web Store extensions.
    return userAgent.includes('chrome')
}

export const isMobileDevice = (): boolean => {
    return window.innerWidth < 640
}

/**
 * Precise mobile-device check (UA + touch capability), independent of viewport size.
 * Use this to decide whether a user is *physically* on a phone/tablet — a desktop user
 * resizing their window to phone width is NOT a mobile device.
 *
 * Covers:
 * - iOS, iPadOS 13+ (reports as "Macintosh") and Android, via `getMobilePlatform`
 * - Other mobile UAs (BlackBerry, IEMobile, Opera Mini, any "Mobi")
 */
export const isMobileDeviceStrict = (): boolean => {
    if (typeof navigator === 'undefined') return false
    return getMobilePlatform() !== null || /Mobi|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export const canUseExtension = (): boolean => {
    return !isMobileDevice() && isChromiumBrowser()
}
